import React from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import {URLS} from "@/lib/urls";
import toFaNumber from "@/lib/utils/number";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {Button, Tag} from "antd";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchStudentAbsence} from "@/api/absence";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {AbsenceTypeEnum} from "@/lib/helper/enumType";

function StudentAbsencesPage(props) {
    const columns = [
        {
            title: 'شناسه درس',
            dataIndex: 'takenunit_id',
            key: 'takenunit_id',
            responsive: ['sm'],
            render: (text) => toFaNumber(text)
        },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => {
                return record?.takenunit?.lesson?.topic?.title
            }
        },
        {
            title: 'نوع',
            dataIndex: 'type',
            key: 'type',
            render: (text, record) => {
                return <Tag className={AbsenceTypeEnum(record?.type, 'color')}>{AbsenceTypeEnum(record?.type)}</Tag>
            }
        },
        {
            title: 'مربی',
            dataIndex: 'teacher',
            key: 'teacher',
            render: function (text, record) {
                return record?.takenunit?.lesson?.teacher_detail?.firstname + ' ' +
                    record?.takenunit?.lesson?.teacher_detail?.lastname;
            }
        },
        {
            title: 'تاریخ غیبت',
            dataIndex: 'datecreated',
            key: 'datecreated',
            render: (text) => {
                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD')
            }
        },
        {
            title: '',
            dataIndex: 'takenunit_id',
            key: 'takenunit_id',
            render: function (text, record) {
                return (<div className={'flex justify-end'}>

                    <Link to={sprintf(URLS.student.lessons.myLesson.detail, {id: text})}>
                        <Button size={'small'} color={'default'} variant={'filled'}>جزئیات</Button>
                    </Link>
                </div>)
            }
        },

    ];

    return (
        <StudentLayout pageTitle={'غیبت‌ها'} backTo={URLS.student.dashboard}>
            <TableSearch
                searchInput={false}
                apiFn={useApiSearchStudentAbsence}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />
        </StudentLayout>
    );
}

export default StudentAbsencesPage;